
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button type="button" class="btn active backtotop-btn" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <ng-icon name="tablerChevronUp"></ng-icon>
    </button>
</div>
